import { ElementRef } from "@angular/core";

export function scrollToFirstInvalidControl(el: ElementRef) {
    setTimeout(() => {
        const firstInvalidControl: HTMLElement = el.nativeElement.querySelector(
            "form .ng-invalid"
        );
        if(firstInvalidControl != null){
            if (!isInViewport(firstInvalidControl))
                window.scroll({
                    top: getTopOffset(firstInvalidControl) - 500,
                    left: 0,
                    behavior: "smooth"
            });
        }
    }, 500);
}

export function getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
}

export function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}